<template>
  <form @submit.prevent="reset">
    <div class="form-group row">
      <div class="col-md-12">
        <label class="pb-2">Introduce una nueva contraseña</label>
        <input
          class="form-control form-password"
          required
          v-model="password"
          :v="$v.password"
           v-on:keyup = "tooCommon = false"
          type="password"
          placeholder="Contraseña"
        />
        <div v-if="$v.password.$error  || tooCommon ">
            <label v-if="!$v.password.minLength" class=" col-form-label invalid p-0">Mínimo 8 caracteres</label>
            <label v-if="!$v.password.notOnlyNumeric" class=" col-form-label invalid p-0">No usar solo numeros</label>
            <label v-if="tooCommon" class=" col-form-label invalid p-0">Demasiado común</label>
        </div>
      </div>
      <!-- input-group.// -->
    </div>
    <!-- form-group// -->
    <div class="form-group row pb-3">
      <div class="col-md-12">
        <input
          class="form-control form-password"
          required
          v-model="password2"
          type="password"
          :v="$v.password2"
          placeholder="Repetir Contraseña"
        />
        <label v-if="$v.password2.$error" class=" col-form-label invalid p-0"
          >Las contraseñas deben ser iguales
        </label>
      </div>
      <!-- input-group.// -->
    </div>
    <!-- form-group// -->
    <div class="form-group row">
      <div class="col-md-8 mx-auto">
        <button type="submit" class="btn-general">
          Enviar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { setData } from "./../../services/api";
import {
  required,
  minLength,
  sameAsPassword,
  sameAs,
  not,
  numeric
} from "vuelidate/lib/validators";
import { common  } from "@/services/validators";
export default {
  name: "reset-pass",
  props: {
    token: String
  },
  data() {
    return {
      password: "",
      password2: "",
      tooCommon: false,
    };
  },
  mounted() {
    this.$store.commit('set_view_name', ['Recuperar contraseña'])
    this.$store.commit('set_view_role', ['Aureal'])
  },
  validations: {
    password: {
      required,
      notOnlyNumeric:not(numeric),
      minLength: minLength(8),
    },
    password2: {required, sameAsPassword: sameAs("password") }
  },
  methods: {
    reset: function() {
      this.$v.password.$touch();
      this.$v.password2.$touch();
      if (this.$v.password.$error || this.$v.password2.$error) return;

      var form = {
        password: this.password,
        token: this.token
      };
      setData("auth-oomur/password-reset/confirm/", form).then(res => {
        if (res.status == 200 && res.data.status == "OK") {
          this.$noty.success("La contraseña ha sido actualizada  correctamente");
          this.$parent.viewComponent = 'login' 
        } else {
          var errors = res.data.password
          if (errors){
            this.tooCommon = true
            this.password = ''
            this.password2 = ''
          }else{
            this.$noty.error("No sé a podido actualizar la contraseña");
            this.password = ''
            this.password2 = ''
          }

        }
      }).catch(error => {
        this.$noty.error("No sé a podido actualizar la contraseña");
      });
    }
  }
};
</script>

<style lang= "scss" scoped>

  $border-color: #32AC91;

</style>
